import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { posthog } from "posthog-js";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const hashParams = new URLSearchParams(window.location.hash.substring(1));
const distinctId = hashParams.get("distinct_id");
const sessionId = hashParams.get("session_id");

posthog.init(process.env.REACT_APP_POSTHOG_API_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
  capture_pageview: false,
  ...(distinctId && sessionId
    ? { bootstrap: { distinctID: distinctId, sessionID: sessionId } }
    : {}),
});

function PostHogPageView() {
  const location = useLocation();
  useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);
  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <PostHogPageView />
      <Routes>
        <Route exact path="/ms" element={<App />} />
        <Route exact path="/ma" element={<App />} />
        <Route exact path="/pdp" element={<App />} />
        <Route exact path="/me" element={<App />} />
        <Route exact path="/" element={<App />} />
        <Route
          exact
          path="*"
          element={
            <div>
              Oops! It seems like we can&apos;t find the form you&apos;re
              looking for. Don&apos;t worry, our health insurance options are
              real and available to help you protect your health and wellbeing.
            </div>
          }
        />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
